import { useDroppable } from '@dnd-kit/core';
import { useTranslation } from 'react-i18next';
import { FolderIconOpen } from '@/utils/icons';
import { tableRowDndId } from './tableRowDndId';
import styles from './DocumentTable.module.css';

export interface IParentRowProps {
  target: { id: string; name: string };
  onOpen: (id: string) => void;
}

// The first row when inside a folder — navigates one level up, file-manager
// style, labelled with the destination folder's name. Also a drop target, so
// dragging an item onto it moves it to the parent folder.
export function ParentRow({ target, onOpen }: IParentRowProps) {
  const { t } = useTranslation();
  const { setNodeRef, isOver } = useDroppable({ id: tableRowDndId(target.id) });

  return (
    <tr
      ref={setNodeRef}
      className={`${styles.row} ${isOver ? styles.dropTarget : ''}`}
      onClick={() => onOpen(target.id)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onOpen(target.id);
        }
      }}
      tabIndex={0}
    >
      <td className={`${styles.td} ${styles.colName}`}>
        <span className={`${styles.nameCell} ${styles.folderNameCell}`}>
          <span className={styles.folderRowIcon}><FolderIconOpen size={16} /></span>
          <span>
            <span className={styles.parentRowLabel}>
              {t('documents.backToParent', { name: target.name })}
            </span>
          </span>
        </span>
      </td>
      <td colSpan={5} className={styles.td} />
    </tr>
  );
}
